<div *ngFor="let toast of toastService.toasts">
    <ngb-toast [class]="'text-dark' + ' ' + 
                        (toast.type=='success' ? 'badge-soft-success' : 
                        (toast.type=='info' ? 'badge-soft-info' : 
                        (toast.type=='warning' ? 'badge-soft-warning' : 'badge-soft-danger')))" 
               [autohide]="true" 
               [animation]="true" 
               (hidden)="toastService.remove(toast)">
        <div>
            <div class="text-center d-inline-block toast-icon">
                <i class="bi" [ngClass]="toast.type=='success' ? 'bi-check2' : 
                                         (toast.type=='info' ? 'bi-info-circle-fill' : 
                                         (toast.type=='warning' ? 'bi-exclamation-triangle-fill' : 'bi-shield-fill-exclamation'))"></i>
            </div>
            <div class="d-inline-block toast-content">
                <div class="row">
                    <div class="col-10 fw-bold">
                        <span *ngIf="toast.type=='success'">{{'General.success'| translate}}</span>
                        <span *ngIf="toast.type=='info'">{{'General.info'| translate}}</span>
                        <span *ngIf="toast.type=='error'">{{'General.error'| translate}}</span>
                        <span *ngIf="toast.type=='warning'">{{'General.warning'| translate}}</span>
                    </div>
                    <div class="col-2 text-end">
                        <button type="button" class="btn-close" (click)="toastService.remove(toast)"></button>
                    </div>
                </div>
                <div>
                    <div *ngFor="let item of toast.data">
                        <span *ngIf="isString(item)">{{item}}</span>
                        <span *ngIf="!isString(item)">{{item.message}}</span>
                    </div>
                    <a *ngIf="toast.type === 'error'"
                       href="javascript:void(0)"
                       class="small mt-1 d-inline-block"
                       style="color: #842029; opacity: 0.75; text-decoration: underline;"
                       (click)="toastService.requestBugReport(); toastService.remove(toast)">
                        <i class="bi bi-bug me-1"></i>{{ 'BugReport.reportBug' | translate }}
                    </a>
                </div>
            </div>
        </div>
    </ngb-toast>
</div>